__turbopack_context__.v({
  "avatarContainer": "test-embed-modal-module__wX_T5G__avatarContainer",
  "avatarSection": "test-embed-modal-module__wX_T5G__avatarSection",
  "chatContainer": "test-embed-modal-module__wX_T5G__chatContainer",
  "chevronIcon": "test-embed-modal-module__wX_T5G__chevronIcon",
  "embedCode": "test-embed-modal-module__wX_T5G__embedCode",
  "embedContainer": "test-embed-modal-module__wX_T5G__embedContainer",
  "embedContent": "test-embed-modal-module__wX_T5G__embedContent",
  "embedHeader": "test-embed-modal-module__wX_T5G__embedHeader",
  "expanded": "test-embed-modal-module__wX_T5G__expanded",
  "modal": "test-embed-modal-module__wX_T5G__modal",
  "modalContent": "test-embed-modal-module__wX_T5G__modalContent",
});
